import { createFileRoute } from '@tanstack/react-router'
import Adhoc from '../../components/Adhoc/Adhoc'
import AdhocList from '../../components/Adhoc/AdhocList';

export const Route = createFileRoute('/adhoc/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Adhoc />
      <AdhocList />
    </>
  );
}
